export const USDC_ON_NAMADA = {
  chain: 'namada:namada.5f5de2dd1b88cba30586420',
  denom: 'ibc/6B199312B29CF047BF8B1337450EF3AA0475FE0C312DB94055F2D5B22CD1E71A',
}

export const OSMO_ON_NAMADA = {
  chain: 'namada:namada.5f5de2dd1b88cba30586420',
  denom: 'ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B',
}

export const SOL_ON_SOLANA = {
  chain: 'solana:mainnet-beta',
  denom: 'solana-native',
}
